import { useUiVersion } from 'hooks';
import { SimpleSelect } from 'libs/ui';
import { CustomSelect } from 'libs/form/lib/inputs/CustomSelect';
import { zones } from 'services/zones';

export const ZoneSelect = (props) => {
  const { name, value, onChange, disabled, ...rest } = props;
  const { isNew } = useUiVersion();
  const items = zones.getZones();

  const optionsEl = items.map((el, idx) => (
    <option key={idx} value={el.zone_id}>
      {el.name}
    </option>
  ));

  // v2: render the shared CP dropdown (green-highlighted selection) so the
  // "Парковочная зона" select matches the "Зона" filter and every other
  // redesign select. The synthetic event keeps the original {name, value}
  // shape the row's onChange reads (event.target.name) — logic is unchanged.
  if (isNew) {
    const input = { value, onChange: (v) => onChange && onChange({ target: { name, value: v } }) };
    return (
      <CustomSelect input={input} disabled={disabled}>
        {optionsEl}
      </CustomSelect>
    );
  }

  return (
    <SimpleSelect name={name} value={value} onChange={onChange} disabled={disabled} {...rest}>
      {optionsEl}
    </SimpleSelect>
  );
};
